import { withStyles } from '@material-ui/core/styles';
import styles from './PaymentInfo.styles';
import PaymentInfo from './PaymentInfo';
import DefaultAddress from './DefaultAddress';

const StyledPaymentInfo = withStyles(styles)(PaymentInfo);
/**
 * Note: By default HOC doesn't pass static methods to new Component
 * @see https://reactjs.org/docs/higher-order-components.html#static-methods-must-be-copied-over
 */
export default Object.assign(StyledPaymentInfo, { DefaultAddress });
